import eData from "./electricityData.json";
const countries = eData.map((data) => data.Entity);

export const getCountries = () => {
  return countries;
};
